"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importStar(require("react"));

const react_spring_1 = require("react-spring");

const SnackbarContainer_1 = __importDefault(require("../snackbar-container/SnackbarContainer"));

const AnimatedSnackbarContainer = _a => {
  var {
    children,
    transition
  } = _a,
      props = __rest(_a, ["children", "transition"]);

  const [refs] = react_1.useState(() => new WeakMap());
  const transitions = react_spring_1.useTransition(children, item => item.key, transition ? typeof transition === 'function' ? transition(refs) : transition : defaultTransition(refs));
  return react_1.default.createElement(SnackbarContainer_1.default, Object.assign({}, props), transitions.map(({
    item,
    props,
    key
  }) => react_1.default.createElement(react_spring_1.animated.div, {
    key: key,
    style: props,
    ref: ref => refs.set(item, ref)
  }, item)));
};

exports.default = AnimatedSnackbarContainer;

const defaultTransition = refs => ({
  from: {
    opacity: 1,
    transform: 'translate3d(100%, 0, 0)'
  },
  enter: item => async next => {
    var _a;

    return await next({
      height: (_a = refs.get(item)) === null || _a === void 0 ? void 0 : _a.offsetHeight,
      transform: 'translate3d(0, 0, 0)'
    });
  },
  leave: {
    opacity: 0,
    height: 0
  }
});